import { Link } from 'react-router-dom';

interface MovieCardProps {
  id: string;
  title: string;
  titleEn: string;
  year: number;
  rating: number;
  duration: string;
  category: string;
  image: string;
  tags: string[];
  isNew?: boolean;
  isHot?: boolean;
  description?: string;
  director?: string;
  cast?: string[];
}

export default function MovieCard({ id, title, titleEn, year, rating, duration, image, tags, isNew, isHot, category }: MovieCardProps) {
  return (
    <Link
      to={`/article/${id}`}
      className="group block cursor-pointer"
    >
      <div className="relative overflow-hidden rounded-lg aspect-[4/5] bg-background-200 mb-3">
        <img
          src={image}
          alt={title}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
          title={`${title} - 被窝影院高清在线观看`}
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/10 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end p-4">
          <div className="text-white">
            <p className="text-sm font-medium">{duration}</p>
            <p className="text-xs mt-1 opacity-80">{year}年</p>
          </div>
        </div>
        {(isNew || isHot) && (
          <div className="absolute top-2 left-2 flex gap-1">
            {isHot && (
              <span className="px-2 py-0.5 bg-accent-500 text-white text-xs font-medium rounded-full whitespace-nowrap">热门</span>
            )}
            {isNew && (
              <span className="px-2 py-0.5 bg-primary-500 text-white text-xs font-medium rounded-full whitespace-nowrap">新片</span>
            )}
          </div>
        )}
        <div className="absolute top-2 right-2 flex items-center gap-1 bg-black/60 backdrop-blur-sm px-2 py-0.5 rounded-full">
          <i className="ri-star-fill text-accent-400 text-xs"></i>
          <span className="text-white text-xs font-medium">{rating}</span>
        </div>
      </div>
      <h3 className="text-sm font-semibold text-foreground-900 group-hover:text-primary-500 transition-colors truncate">{title}</h3>
      <p className="text-xs text-foreground-500 mt-0.5 truncate">{titleEn} · {year}</p>
      <div className="flex gap-1 mt-1.5 flex-wrap">
        {tags.slice(0, 2).map(tag => (
          <span key={tag} className="px-1.5 py-0.5 bg-secondary-100 text-secondary-700 text-xs rounded whitespace-nowrap">{tag}</span>
        ))}
      </div>
    </Link>
  );
}